import { render } from "./RadarComexView.vue?vue&type=template&id=05c0a110&scoped=true"
import script from "./RadarComexView.vue?vue&type=script&lang=js"
export * from "./RadarComexView.vue?vue&type=script&lang=js"

import "./RadarComexView.vue?vue&type=style&index=0&id=05c0a110&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c0a110"]])

export default __exports__